import React from 'react';
import { motion } from 'framer-motion';
import { WHATSAPP_LINK } from '../lib/constants';
import { MessageCircle, Mail } from 'lucide-react';
export function Hero() {
  const scrollToContact = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const contactSection = document.getElementById('contacto');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="inicio" className="relative min-h-[80vh] sm:min-h-[90vh] flex items-center overflow-hidden" data-id="element-223">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-224">
        <img src="https://cdn.magicpatterns.com/uploads/c9rm2y8V9T9hutvWSid2LL/imagen_principal.jpg" alt="Técnico de fumigación MOBAL trabajando" className="w-full h-full object-cover object-[center_20%] md:object-[center_15%]" data-id="element-225" />
        <div className="absolute inset-0 bg-mobal-black/70" data-id="element-226"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-mobal-black/90 via-mobal-black/60 to-transparent" data-id="element-227"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-7xl" data-id="element-228">
        <div className="max-w-2xl" data-id="element-229">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-mobal-green font-body font-bold text-sm md:text-base uppercase tracking-wider mb-4" data-id="element-230">
            CONTROL PROFESIONAL
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-mobal-white mb-6 leading-tight" data-id="element-231">
            EL FIN DE
            <br data-id="element-232" />
            LAS <span className="text-mobal-green" data-id="element-233">PLAGAS.</span>
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-2 mb-10" data-id="element-234">
            <p className="text-lg md:text-xl text-gray-200 font-body" data-id="element-235">
              Soluciones rápidas, seguras y efectivas.
            </p>
            <p className="text-lg md:text-xl text-gray-200 font-body" data-id="element-236">
              Eliminamos el problema{' '}
              <span className="text-mobal-green font-bold" data-id="element-237">de raíz</span> en
              hogares y empresas.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col sm:flex-row items-start gap-4" data-id="element-238">
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-mobal-green text-mobal-black font-bold py-4 px-8 rounded-md hover:bg-[#b5ff33] transition-colors min-h-[56px] text-lg" data-id="element-239">
              <MessageCircle className="w-6 h-6" data-id="element-240" />
              CONSULTAR POR WHATSAPP
            </a>

            <a href="mailto:mobalfumigaciones@gmail.com" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-transparent border-2 border-mobal-white text-mobal-white font-bold py-4 px-8 rounded-md hover:bg-mobal-white hover:text-mobal-black transition-colors min-h-[56px] text-lg" data-id="element-241">
              <Mail className="w-6 h-6" data-id="element-242" />
              CONTACTO POR EMAIL
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}